<style lang="less" scoped>
.margin-tb {
  height: 32px;
  margin-top: 4px;
}

.title-div {
  font-weight: 600;
  margin: 20px 0;
  font-size: 26px;
  flex-grow: 1;
  color: #000;
  height: 30px;
}

.el-dialog__body {
  padding: 10px 40px 40px;
}

.msg_con {
  min-height: 200px;
  width: 50%;
  padding-left: 50px;

  div {
    margin-top: 10px;
  }

  .title {
    min-width: 80px;
  }

  table {
    margin-top: 20px;

    tr {
      th {
        border: 1px solid #eaeaea;
        background: #FAFAFA;
        color: #8F9BB3;
      }

      td {
        border: 1px solid #eaeaea;
        color: #8F9BB3;
      }
    }
  }
}

.msg_con:first-of-type {
  padding-right: 50px;
  border-right: 1px solid #eeeff3;
}
</style>

<template>
  <div>
    <div class="title-div">报文日志</div>
    <!-- 筛选 -->
    <div class="page-action-btns flex margin-tb-10">
      <div class="flex-grow-1"></div>
      <el-date-picker size="small" type="date" placeholder="请选择日期" value-format="yyyy-MM-dd"
        v-model="queryInfo.fromTime">
      </el-date-picker>
      <el-button type="primary" size="small" @click="getListData(pagination, true)">
        搜 索
      </el-button>
    </div>
    <!-- 表格 -->
    <ZD-table :tableColumns="pageConfig.logListColumns" :operates="operates" :tableData="tableData"
      :tableConfig="pageConfig.tableConfig" :selections="selections" v-on:updateSelections="
        (sels) => {
          selections = sels;
        }
      "></ZD-table>
    <!-- 分页 -->
    <div class="list-pagination">
      <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"></ZD-pagination>
    </div>
    <!-- 操作日志 -->
    <el-dialog title="查看报文" width="60%" :visible.sync="showDialog">
      <div class="flex">
        <div class="msg_con">
          <div class="flex">
            <div class="title">第一条消息:</div>
            <div>{{ logInfo.firstMessage || '暂无数据' }}</div>
          </div>
          <div class="flex">
            <div class="title">第一条消息类型名称:</div>
            <div>{{ logInfo.firstMessageTypeName || '暂无数据' }}</div>
          </div>
          <!-- 表格解析暂隐藏
          <table border='1' cellpadding="10" cellspacing='0'
            style="width:100%;text-align:center;border:1px solid #eaeaea">
            <tr>
              <th>字段</th>
              <th>解析内容</th>
            </tr>
            <tr>
              <td>桩状态</td>
              <td>{{ dialogTable.pileStatus }}</td>
            </tr>
            <tr>
              <td>故障描述</td>
              <td>{{ dialogTable.errorDesc }}</td>
            </tr>
            <tr>
              <td>电压</td>
              <td>{{ dialogTable.voltage }}</td>
            </tr>
            <tr>
              <td>电流</td>
              <td>{{ dialogTable.current }}</td>
            </tr>
            <tr>
              <td>电表读数</td>
              <td>{{ dialogTable.ammeter }}</td>
            </tr>
          </table>
          -->
        </div>
        <div class="msg_con">
          <div class="flex">
            <div class="title">第二条消息:</div>
            <div>{{ logInfo.secondMessage  || '暂无数据'}}</div>
          </div>
          <div class="flex">
            <div class="title">第二条消息类型名称:</div>
            <div>{{ logInfo.secondMessageTypeName || '暂无数据' }}</div>
          </div>
          <!-- 表格解析暂隐藏
          <table border cellspacing='0' style="width:100%;text-align:center;border:1px solid #eaeaea">
            <tr>
              <th>字段</th>
              <th>解析内容</th>
            </tr>
            <tr>
              <td>桩状态</td>
              <td>{{ dialogTable.pileStatus }}</td>
            </tr>
            <tr>
              <td>故障描述</td>
              <td>{{ dialogTable.errorDesc }}</td>
            </tr>
            <tr>
              <td>电压</td>
              <td>{{ dialogTable.voltage }}</td>
            </tr>
            <tr>
              <td>电流</td>
              <td>{{ dialogTable.current }}</td>
            </tr>
            <tr>
              <td>电表读数</td>
              <td>{{ dialogTable.ammeter }}</td>
            </tr>
          </table>
          -->
        </div>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      tableData: [], // 表格数据
      selections: [], // 表格选项
      pagination: {
        current: 1,
        total: 0,
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
      },
      pileCode: "",
      queryInfo: {}, // 搜索字段：pileCode、pageNum、pageSize、fromTime（与充电桩 log-list 一致）
      operates: {
        width: 220,
        fixed: "right",
        list: [
          {
            id: "check",
            label: "报文查看",
            type: "primary",
            show: true,
            disabled: false,
            method: (index, row) => {
              this.toDetail(row);
            },
          },
        ],
      },
      showDialog: false, // 弹窗
      logInfo: {},
      dialogTable: {},
    };
  },
  methods: {
    init() {
      // 列表选中行写入 pileObj：请求报文列表需 pileCode；与设备编号对应字段可能是 pileCode / deviceCode / rcsCode（与接口里 rcsCode 一致）
      const o = this.$store.state.pileObj;
      this.pileCode =
        (o && (o.pileCode || o.deviceCode || o.rcsCode)) || "";
      this.getListData(this.pagination, true);
    },
    // 获取表格数据（请求体与充电桩报文日志相同字段；接口为 getShareDeviceRecord）
    getListData(pagination, reload = false) {
      let _ = this;
      _.$U.showLoading(_);
      _.queryInfo.pileCode = _.pileCode;
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        this.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      const params = {
        ..._.queryInfo,
      };
      if (_.queryInfo.fromTime) {
        params.fromTime = `${_.queryInfo.fromTime} 00:00:00`;
        params.toTime = `${_.queryInfo.fromTime} 23:59:59`;
      } else {
        delete params.fromTime;
        delete params.toTime;
      }
      _.$H.post(_, _.$A.digitization.getShareDeviceRecord, params).then((res) => {
        console.log(res);
        _.tableData = res.data.data.content || [];
        _.pagination.total = res.data.data.totalElements || 0;
        _.$U.hideLoading(_);
      });
    },
    /** 接口多为对象；若为字符串则 JSON 解析 */
    parseTransMessage(tm) {
      if (tm == null || tm === "") return {};
      if (typeof tm === "string") {
        try {
          return JSON.parse(tm) || {};
        } catch (e) {
          return {};
        }
      }
      return tm;
    },
    /** transMessage 里是否已有可展示的解析字段 */
    hasMeaningfulParse(dt) {
      if (!dt || typeof dt !== "object") return false;
      return !!(
        dt.pileStatus ||
        dt.errorDesc ||
        dt.voltage ||
        dt.current ||
        dt.ammeter
      );
    },
    /**
     * transMessage 为 null 时（如心跳包），后端可能只在 v3DataAreaDataMap 里给监测数据
     * 格式对齐 transMessage：充电枪n : 数值
     */
    buildDialogTableFromV3Map(row) {
      const map = row.v3DataAreaDataMap;
      if (!map || typeof map !== "object") return null;
      const keys = Object.keys(map).sort();
      if (!keys.length) return null;
      const gun = map[keys[0]];
      if (!gun || typeof gun !== "object") return null;
      const port = gun.gunPort != null ? gun.gunPort : keys[0];
      const label = Number.isFinite(parseInt(String(port), 10))
        ? parseInt(String(port), 10)
        : port;
      let cur = gun.currentLa;
      if ((cur == null || cur === "") && gun.currentLb) cur = gun.currentLb;
      if ((cur == null || cur === "") && gun.currentLc) cur = gun.currentLc;
      const voltage =
        gun.pressureUa != null && gun.pressureUa !== ""
          ? `充电枪${label} : ${gun.pressureUa}  `
          : "";
      const current =
        cur != null && cur !== "" ? `充电枪${label} : ${cur}  ` : "";
      const ammeter =
        gun.totalDegree != null && gun.totalDegree !== ""
          ? `充电枪${label} : ${gun.totalDegree}  `
          : "";
      if (!voltage && !current && !ammeter) return null;
      return {
        pileStatus: "",
        errorDesc: "",
        voltage,
        current,
        ammeter,
      };
    },
    toDetail(row) {
      this.logInfo = row;
      let dt = this.parseTransMessage(row.transMessage);
      if (!this.hasMeaningfulParse(dt)) {
        const fromV3 = this.buildDialogTableFromV3Map(row);
        if (fromV3) dt = fromV3;
      }
      this.dialogTable = dt || {};
      this.showDialog = true;
    },
  },
  mounted() {
    this.init();
  },
};
</script>
